import { buildGetter } from "@dcc/store/utils";
import {
  DrinkingDay,
  UnitAndCalories,
  UnitsAndCaloriesPerDay
} from "@dcc/types/drinkingDay";
import { RiskLevel } from "@dcc/types/riskLevel";
import { GetterTree, Store } from "vuex";

import { IRootState } from "../../types";
import { ScoreState } from "../types";
import { getters as auditCGetters } from "./auditCGetters";
import { getters as conversionGetters } from "./conversionGetters";
import { getters as dailyGetters } from "./dailyGetters";
import { getters as dangerousLevelsGetters } from "./dangerousLevelsGetters";
import { GetterNames } from "./names";
import { getters as percentageGetters } from "./percentageGetters";
import { getters as riskLevelGetters } from "./riskLevelGetters";
import { getters as weeklyGetters } from "./weeklyGetters";

export const getters: GetterTree<ScoreState, IRootState> = {
  ...auditCGetters,
  ...conversionGetters,
  ...dailyGetters,
  ...dangerousLevelsGetters,
  ...percentageGetters,
  ...weeklyGetters,
  ...riskLevelGetters
};

export const findGetters = (store: Store<IRootState>) => {
  return {
    getAuditCScore: () =>
      buildGetter<number>(store, "score", GetterNames.AUDITCSCORE),
    getCaloriesAndUnitsForEachDay: () =>
      buildGetter<UnitsAndCaloriesPerDay[]>(
        store,
        "score",
        GetterNames.CALORIESANDUNITSFOREACHDAY
      ),
    getRiskLevel: () =>
      buildGetter<RiskLevel>(store, "score", GetterNames.RISKLEVEL),
    getRiskLevelBeforeChanges: () =>
      buildGetter<RiskLevel>(
        store,
        "score",
        GetterNames.RISKLEVELBEFORECHANGES
      ),
    getIsBingeDrinker: () =>
      buildGetter<boolean>(store, "score", GetterNames.ISBINGEDRINKER),
    getIsLowRiskBingeDrinker: () =>
      buildGetter<boolean>(store, "score", GetterNames.ISLOWRISKBINGEDRINKER),
    getIsDangerousToHealth: () =>
      buildGetter<boolean>(store, "score", GetterNames.ISDANGEROUSTOHEALTH),
    getWeeklyUnitsAndCalories: () =>
      buildGetter<UnitAndCalories>(
        store,
        "score",
        GetterNames.WEEKLYUNITSANDCALORIES
      ),
    getWeeklyCaloriesAsBurgers: () =>
      buildGetter<number>(store, "score", GetterNames.WEEKLYCALORIESASBURGERS),
    getWeeklyUnitsAsSpirits: () =>
      buildGetter<number>(store, "score", GetterNames.WEEKLYUNITSASSPIRITS),
    getWeeklyUnitsAsBeers: () =>
      buildGetter<number>(store, "score", GetterNames.WEEKLYUNITSASBEERS),
    getPercentWhoDrinkLess: () =>
      buildGetter<number>(store, "score", GetterNames.PERCENTWHODRINKLESS),
    getWeeklyUnitsAsDrinks: () =>
      buildGetter<DrinkingDay>(store, "score", GetterNames.WEEKLYUNITSASDRINKS),
    getWeeklyDrinks: () =>
      buildGetter<DrinkingDay>(store, "score", GetterNames.WEEKLYDRINKS)
  };
};
